export const classifications = {
  'Likely False Alarm': {
    label: 'Likely false alarm',
    class: 'likely-false-alarm',
  },
  'Likely Trip': {
    label: 'Likely trip',
    class: 'likely-trip',
  },
  'Likely Energization': {
    label: 'Likely energization',
    class: 'likely-energization',
  },
  'Likely De-energization': {
    label: 'Likely de-energization',
    class: 'likely-de-energization',
  },
};

export const filterMapping = {
  showNoClassification: 'No Classification',
  showLikelyTrip: 'Likely Trip',
  showLikelyEnergization: 'Likely Energization',
  showLikelyDeEnergization: 'Likely De-energization',
  showLikelyFalseAlarm: 'Likely False Alarm',
};

export const normalizeClassification = (classification) => {
  if (!classification) return null;
  const trimmed = classification.trim();
  const key = Object.keys(classifications).find((k) => k.toLowerCase() === trimmed.toLowerCase());
  return key || classification;
};
